import { render, staticRenderFns } from "./AccAddWeChat.vue?vue&type=template&id=cde7b670&scoped=true&"
import script from "./AccAddWeChat.vue?vue&type=script&lang=js&"
export * from "./AccAddWeChat.vue?vue&type=script&lang=js&"
import style0 from "./AccAddWeChat.vue?vue&type=style&index=0&id=cde7b670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde7b670",
  null
  
)

export default component.exports